import ProfileTab from "@features/PersonalSettings/ui/ProfileTab";
import { Typography } from "@shared/ui";
import React from "react";
import styles from "./styles.module.scss";

const { Title, Text } = Typography;

const PersonalSettingsPage: React.FC = () => {
  return (
    <div className={styles.personalSettingsPage}>
      <header className={styles.header}>
        <h1 className={styles.title}>Personal Settings</h1>
        {/* <Text type="secondary">
          Manage your profile details and preferences.
        </Text> */}
      </header>
      <ProfileTab />
    </div>
  );
};

export default PersonalSettingsPage;
